<template>
    <div class="card mt-1">
        <div class="card-body">
            <div class="help-title p-2">Help</div>
            <div class="subTitle p-2 pb-0">Need help with something?</div>
            <div class="sub-text p-2 pt-0">Get in touch with our support team.</div>
            <div class="mt-3 p-2">
              <img class="phone-icon" src="@/assets/images/driver/phone.png" />
            </div>
            <div class="help-text p-2 pt-0">Call Monday to Friday 10:30am to 5pm</div>
            <div class="help-value p-2 pt-0">0280&nbsp;060&nbsp;696</div>
            <div class="mt-3 p-2">
              <img class="emial-icon" src="@/assets/images/driver/email.png" />
            </div>
            <div class="help-text p-2 pt-0">Drop us an email</div>
            <div class="help-value p-2 pt-0">support@taxi1.com.au</div>
            <div class="mt-3 p-2">
              <img class="sms-icon" src="@/assets/images/driver/sms.png" />
            </div>
            <div class="help-text p-2 pt-0">Send us an SMS</div>
            <div class="help-value p-2 pt-0">0466&nbsp;048&nbsp;009</div>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
        </div>

    </div>
</template>


<script setup>

</script>


<style scoped>
.card {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 100%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: auto;
    overflow-x: hidden; /* 防止左右滑動 */
}

.help-title{
  width: 169px;
  height: 30px;
  left: 30px;

  /* Portal/Portal – H4 bold */
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;

  /* 1E1E2D */
  color: #1E1E2D;
}

.subTitle{
  margin-top: 40px;
  width: 330px;

  /* Portal/Portal – H5 */
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;

  /* Navy */
  color: #051C2C;

  /* Inside auto layout */
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

}

.sub-text{
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;

  width: 50%;
}

.phone-icon{
  width: 19px;
  height: 26px;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}

.emial-icon{
  width: 26px;
  height: 19px;


  flex: none;
  order: 0;
  flex-grow: 0;
}

.sms-icon{
  width: 26px;
  height: 26px;


  flex: none;
  order: 0;
  flex-grow: 0;
}

.help-text{
  /* Portal/Portal – body small */
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  /* identical to box height */

  /* Navy */
  color: #051C2C;


  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}

.help-value{
  /* Portal/Portal – H5 */
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  display: flex;
  align-items: center;

  /* Green */
  color: #00C962;


  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}


</style>

